export interface Problem {
  id: string;
  name: string;
  prompt: string;
  software: string;
  created_at: string;
  created_by: string;
}

export interface ProblemRun {
  id: string;
  problem_id: string;
  job_id: string;
  score: number | null;
  final_score?: number | null;
  status: "pending" | "running" | "completed" | "failed" | "cancelled";
  batch_job_name?: string | null;
  created_at: string;
  updated_at: string;
  error?: string | null;
  is_public?: boolean;
}

export interface Screenshot {
  index: number;
  action: string;
  description: string;
  input: {
    action: string;
    coordinate?: [number, number];
    startCoordinate?: [number, number];
    endCoordinate?: [number, number];
    text?: string;
    direction?: string;
    amount?: number;
    [key: string]: unknown;
  };
  screenshot: string;
  timestamp: string | null;
  thoughtProcess?: string;
  toolName?: string;
  toolInput?: Record<string, unknown> | string;
  toolResultText?: string;
  isToolError?: boolean;
  toolCommand?: string;
}

export interface ScreenshotData {
  problem_name: string;
  run_id: string;
  total_screenshots: number;
  screenshots: Screenshot[];
}

export enum LabelType {
  SUCCESS = "success",
  FAILED = "failed",
}

export interface HumanLabel {
  id: string;
  problem_run_id: string;
  user_id: string;
  label: LabelType;
  notes: string | null;
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
  user_username?: string | null;
  labeling_project_id?: string | null;
}

export interface ScoreDispute {
  id: string;
  problem_run_id: string;
  user_id: string;
  note: string;
  proposed_score: "success" | "failed" | "bad_task";
  status: "pending" | "accepted" | "rejected";
  reason: string | null;
  created_at: string;
  updated_at: string;
  current_score?: number | null;
  final_score?: number | null;
  problem_name?: string;
  resolved_by_user_id?: string | null;
  resolved_by_username?: string | null;
  final_status?: string | null;  // The final status set during resolution
  is_problem_creator?: boolean | null;  // Whether the dispute was created by the problem creator
}
